import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'primereact/tooltip';
import HookStatusPill from './HookStatusPill';
import HookPreview from './HookPreview';
import formatRelativeDate from '../../services/formatRelativeDate';
import './hooks.css';

// One hook as the reader will meet it — question, the two options with
// the correct one marked, the reveal line — with the approval decision
// beside it.
export default function HookApprovalCard({ hook, courseName, busy, onToggleApproval, onEdit, onDelete }) {
    const approved = hook.status === 'approved';
    const updated = formatRelativeDate(hook.updated_at);
    const dateCls = `hk-card-date-${hook.id}`;
    return (
        <div className={`hk-card${approved ? ' hk-card-approved' : ''}`} data-testid={`hook-card-${hook.id}`}>
            <div className="hk-card-main">
                <div className="hk-card-question">{hook.question}</div>
                <div className="hk-card-options">
                    {hook.options.map((label, index) => (
                        <span
                            key={label + index}
                            className={`hk-card-option${index === hook.correct_index ? ' hk-card-option-correct' : ''}`}
                            title={index === hook.correct_index ? 'Correct answer' : undefined}
                        >
                            {label}
                            {index === hook.correct_index && <i className="pi pi-check" />}
                        </span>
                    ))}
                </div>
                <HookPreview hook={hook} courseName={courseName} />
            </div>
            <div className="hk-card-side">
                <div className="hk-card-meta">
                    <HookStatusPill status={hook.status} />
                    {hook.updated_at && (
                        <>
                            <span className={`hk-muted ${dateCls}`} data-pr-tooltip={updated.full} data-pr-position="top">
                                {updated.short}
                            </span>
                            <Tooltip target={`.${dateCls}`} />
                        </>
                    )}
                </div>
                <div className="hk-card-actions">
                    <button
                        type="button"
                        className={`hk-btn hk-btn-sm${approved ? '' : ' hk-btn-primary'}`}
                        disabled={busy}
                        onClick={() => onToggleApproval(hook)}
                    >
                        <i className={`pi ${approved ? 'pi-times' : 'pi-check'}`} />
                        {approved ? 'Revoke' : 'Approve'}
                    </button>
                    <button type="button" className="hk-btn hk-btn-sm" disabled={busy} onClick={() => onEdit(hook)}>
                        <i className="pi pi-pencil" /> Edit
                    </button>
                    <button type="button" className="hk-btn hk-btn-sm hk-btn-danger" disabled={busy} onClick={() => onDelete(hook)}>
                        <i className="pi pi-trash" /> Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

export const hookShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    course_id: PropTypes.number,
    question: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    correct_index: PropTypes.number.isRequired,
    explanation: PropTypes.string,
    bridge: PropTypes.string,
    status: PropTypes.string.isRequired,
    position: PropTypes.number,
    updated_at: PropTypes.number,
});

HookApprovalCard.propTypes = {
    hook: hookShape.isRequired,
    courseName: PropTypes.string,
    busy: PropTypes.bool,
    onToggleApproval: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

HookApprovalCard.defaultProps = { courseName: '', busy: false };
